import { Grid2, Skeleton } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useAuth } from "../../hooks/useAuth";

export default function UserCardSkeleton() {
    const { user } = useAuth()

    return (
        <Grid2 container sx={{ backgroundColor: 'rgba(0,0,0,0.05)', borderRadius: 4 }} padding={2} minWidth={'15vw'} gap={2} alignItems={'center'} justifyContent={'space-between'}>
            <Grid2 container gap={2} alignItems={'center'}>
                <Grid2>
                    <Skeleton variant="circular" width={50} height={50} />
                </Grid2>
                <Grid2 container flexDirection={'row'} gap={2}>
                    <Grid2>
                        <Skeleton variant="text" width={100} />
                    </Grid2>
                    <Grid2>
                        <Skeleton variant="text" width={75} />
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 container gap={1}>
                <Grid2 display={user?.role === 'admin' ? 'flex' : 'none'}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid2>
                <Grid2>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid2>
            </Grid2>
        </Grid2>
    )
}